import * as React from 'react';
import { connect } from 'react-redux';
import { Button, FormControl, FormGroup, ControlLabel, Checkbox, Row, Col } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import * as brokerActions from '../actions/BrokerActions';
import TreeView from '../../../components/common/TreeView/TreeView';
import * as BrokerTreeTypes from '../BrokerTreeTypes';
import { assign } from '../../../shared/Assign';
import * as Features from '../../../shared/Features';
import ChainModal from '../chain/ChainModal';
import FirmGroupModal from '../firmGroup/FirmGroupModal';
import FirmModal from '../firm/FirmModal';
import { handleError } from '../../../shared/ErrorCatching';
import AgentModal from '../agent/AgentModal';
import notify from '../../../shared/feedback/notifications';
import LogsModal from '../../logs/LogsModal';
import ConfirmationModal from '../../../components/common/ConfirmationModal';

class BrokerTreePage extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            brokerTreeNodes: [],
            selectedItem: {},
            searchFilter: '',
            showLogs: false,
            logProperty: 'BrokerFirmId',
            logEntityId: 0,
            showMoveNodeConfirmModal: false,
            showDeleteNodeConfirmModal: false,
            showRestoreNodeConfirmModal: false,
            alterNodeId: -1,
            targetNodeId: -1,
            showRemovedNodes: false,
            unchangedBrokerTreeNodes: [],
            openedModalByParam: undefined,
            updatedTreeWhenEmpty: 0,
            activeSearch: false,
            searching: false
        };

        this.search = this.search.bind(this);
        this.updateTree = this.updateTree.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.addNewItem = this.addNewItem.bind(this);
        this.moveNode = this.moveNode.bind(this);
        this.doNodeMove = this.doNodeMove.bind(this);
        this.deleteNode = this.deleteNode.bind(this);
        this.doNodeDelete = this.doNodeDelete.bind(this);
        this.closeAlterNodeConfirmModal = this.closeAlterNodeConfirmModal.bind(this);
        this.closeModals = this.closeModals.bind(this);
        this.toggleLogs = this.toggleLogs.bind(this);
        this.hasChildren = this.hasChildren.bind(this);
        this.toggleShowRemoved = this.toggleShowRemoved.bind(this);
        this.restoreNode = this.restoreNode.bind(this);
        this.doNodeRestore = this.doNodeRestore.bind(this);
        this.findNode = this.findNode.bind(this);
        this.toggleNode = this.toggleNode.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.toggleNodeLocal = this.toggleNodeLocal.bind(this);
        this.openNodeModal = this.openNodeModal.bind(this);
    }

    componentDidMount() {
        if (this.props.match.params.nodeId) {
            this.setState({
                openedModalByParam: this.props.match.params.nodeId
            });
        }

        this.props.actions
            .getBrokerTree(null, null, null, this.props.match.params.nodeId)
            .then(() => {
                if (this.props.match.params.nodeId) {
                    this.openNodeModal(this.props.match.params.nodeId);
                }
            });
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        let tree = assign([], nextProps.brokerTreeNodes);
        let nodes = this.setShowForNode(
            this.sortBrokerTreeByTypeThenName(tree),
            this.state.showRemovedNodes
        );
        this.setState({ brokerTreeNodes: nodes }, () => {
            if (
                (!this.props.brokerTreeNodes || this.props.brokerTreeNodes.length === 0) &&
                this.state.updatedTreeWhenEmpty < 3
            ) {
                this.updateTree(tree);
                this.setState({
                    updatedTreeWhenEmpty: this.state.updatedTreeWhenEmpty + 1
                });
            } else {
                this.setState({ updatedTreeWhenEmpty: 0 });
            }
        });

        if (nextProps.match.params.nodeId !== this.state.openedModalByParam) {
            this.setState({
                openedModalByParam: nextProps.match.params.nodeId
            });
            this.props.actions
                .getBrokerTree(null, null, null, nextProps.match.params.nodeId)
                .then(() => {
                    this.openNodeModal(nextProps.match.params.nodeId);
                });
        }
    }

    openNodeModal(nodeId: string) {
        let tree = assign([], this.props.brokerTreeNodes);
        let nodes = this.setShowForNode(
            this.sortBrokerTreeByTypeThenName(tree),
            this.state.showRemovedNodes
        );
        let item = this.findNode(nodes, parseInt(nodeId));
        if (item) {
            this.selectItem(item);
        }
    }

    getToggledIds(brokerTreeNodes) {
        let idsToggled = [];
        brokerTreeNodes.forEach((node: any) => {
            if (node.toggle) {
                idsToggled = [...idsToggled, node.id];
                if (node.children && node.children.length > 0) {
                    idsToggled = [...idsToggled, ...this.getToggledIds(node.children)];
                }
            }
        });

        return idsToggled;
    }

    sortBrokerTreeByTypeThenName(nodes: any[]) {
        nodes = nodes.sort((a: any, b: any) => {
            if (a.type === b.type) {
                return a.name.localeCompare(b.name, 'sv');
            }

            if (BrokerTreeTypes.Chain === a.type) {
                if (b.type !== BrokerTreeTypes.Chain) {
                    return -1;
                }
            }

            if (BrokerTreeTypes.FirmGroup === a.type) {
                if (b.type === BrokerTreeTypes.Chain) {
                    return 1;
                }

                if (b.type !== BrokerTreeTypes.FirmGroup) {
                    return -1;
                }
            }

            if (BrokerTreeTypes.Firm === a.type) {
                if (b.type === BrokerTreeTypes.Chain || b.type === BrokerTreeTypes.FirmGroup) {
                    return 1;
                }

                if (b.type !== BrokerTreeTypes.Firm) {
                    return -1;
                }
            }

            return 0;
        });

        nodes.forEach((item) => {
            if (item.children) {
                item.children = this.sortBrokerTreeByTypeThenName(item.children);
            }
        });

        return nodes;
    }

    updateTree(tree: any[]) {
        if (this.state.searchFilter !== '') {
            this.setState({ brokerTreeNodes: tree });
        } else {
            this.props.actions.updateBrokerTree(tree);
        }
    }

    findNode(nodes: any[], itemId: number) {
        for (let i = 0; i < nodes.length; i++) {
            if (nodes[i].id === itemId) {
                return nodes[i];
            }

            if (nodes[i].children) {
                let item: any = this.findNode(nodes[i].children, itemId);

                if (item) {
                    return item;
                }
            }
        }

        return null;
    }

    addNewItem(item: any, type: any) {
        let currentItem = { parentId: item.id };

        if (type === BrokerTreeTypes.Chain) {
            this.setState({ showChainModal: true, currentItem: currentItem });
        } else if (type === BrokerTreeTypes.FirmGroup) {
            this.setState({
                showFirmGroupModal: true,
                currentItem: currentItem
            });
        } else if (type === BrokerTreeTypes.Firm) {
            this.setState({ showFirmModal: true, currentItem: currentItem });
        } else if (type === BrokerTreeTypes.Agent) {
            this.setState({ showAgentModal: true, currentItem: currentItem });
        }
    }

    selectItem(item: any) {
        if (item.type === BrokerTreeTypes.Chain) {
            this.setState({ showChainModal: true, currentItem: item });
        } else if (item.type === BrokerTreeTypes.FirmGroup) {
            this.setState({ showFirmGroupModal: true, currentItem: item });
        } else if (item.type === BrokerTreeTypes.Firm) {
            this.setState({ showFirmModal: true, currentItem: item });
        } else if (item.type === BrokerTreeTypes.Agent) {
            this.setState({ showAgentModal: true, currentItem: item });
        }
    }

    moveNode(target: any, item: any) {
        this.setState({
            showMoveNodeConfirmModal: true,
            showDeleteNodeConfirmModal: false,
            showRestoreNodeConfirmModal: false,
            alterNodeId: item.id,
            targetNodeId: target.id
        });
    }

    doNodeMove() {
        this.props.actions
            .moveBrokerTreeNode(this.state.alterNodeId, {
                parentId: this.state.targetNodeId
            })
            .then(() => {
                this.closeAlterNodeConfirmModal();
            });
    }

    deleteNode(item: any) {
        this.setState({
            showMoveNodeConfirmModal: false,
            showDeleteNodeConfirmModal: true,
            showRestoreNodeConfirmModal: false,
            alterNodeId: item.id,
            targetNodeId: -1
        });
    }

    hasChildren(nodeTree?: any) {
        let nodes = nodeTree ? nodeTree : this.state.brokerTreeNodes;
        let component = this;

        return nodes.some((node: any) => {
            let exists = false;
            if (node.id === component.state.alterNodeId) {
                return node.children && node.children.length > 0;
            } else if (node.children) {
                return component.hasChildren(node.children);
            }
        });
    }

    doNodeDelete() {
        this.props.actions
            .deleteBrokerTreeNode(this.state.alterNodeId)
            .then(() => {
                this.closeAlterNodeConfirmModal();
                notify.success(Translate('broker-tree/delete/success'));
            })
            .catch((error: any) => handleError(error));
    }

    closeAlterNodeConfirmModal() {
        this.setState({
            showMoveNodeConfirmModal: false,
            showDeleteNodeConfirmModal: false,
            showRestoreNodeConfirmModal: false,
            alterNodeId: -1,
            targetNodeId: -1
        });
    }

    search(e: any) {
        let lowerCaseSearchFilter = e.target.value.toLowerCase();
        this.setState({ searchFilter: lowerCaseSearchFilter });
    }

    onSearch() {
        this.props.history.push('/brokers');
        this.setState({ searching: true });
        this.props.actions
            .getBrokerTree(null, null, this.state.searchFilter)
            .then(() => {
                this.setState({
                    activeSearch: this.state.searchFilter.length > 0,
                    openedModalByParam: undefined
                });
            })
            .catch(handleError)
            .then(() => {
                this.setState({ searching: false });
            });
    }

    filter(nodes: any[], filter: string, parentHasAdded: boolean = false) {
        let newNodes: any = [];
        for (let i = 0; i < nodes.length; i++) {
            let hasAdded = false;
            if (parentHasAdded || nodes[i].name.toLowerCase().indexOf(filter) > -1) {
                newNodes.push(nodes[i]);
                hasAdded = true;
            }

            if (nodes[i].children) {
                let newChildren = this.filter(nodes[i].children, filter, hasAdded);

                nodes[i].children = newChildren.length > 0 ? newChildren : null;

                if (newChildren.length > 0) {
                    nodes[i].toggle = true;

                    if (!hasAdded) {
                        newNodes.push(nodes[i]);
                    }
                } else {
                    nodes[i].toggle = false;
                }
            }
        }

        return newNodes;
    }

    toggleShowRemoved() {
        this.setState({
            showRemovedNodes: !this.state.showRemovedNodes,
            brokerTreeNodes: this.setShowForNode(
                this.state.brokerTreeNodes,
                !this.state.showRemovedNodes
            )
        });
    }

    setShowForNode(brokerTreeNodes: any, showRemovedNodes: boolean) {
        let nodes = assign([], brokerTreeNodes);
        return nodes.map((node: any) => {
            if (node.isRemoved) {
                node.show = showRemovedNodes;
                if (node.children && node.children.length > 0) {
                    node.children = this.setShowForNode(node.children, showRemovedNodes);
                }
                return node;
            } else {
                node.show = true;
                if (node.children && node.children.length > 0) {
                    node.children = this.setShowForNode(node.children, showRemovedNodes);
                }
                return node;
            }
        });
    }

    restoreNode(item: any) {
        this.setState({
            showMoveNodeConfirmModal: false,
            showDeleteNodeConfirmModal: false,
            showRestoreNodeConfirmModal: true,
            alterNodeId: item.id,
            targetNodeId: -1
        });
    }

    hasRemovedParent(nodeTree?: any) {
        let nodes = nodeTree ? nodeTree : this.state.brokerTreeNodes;
        let component = this;

        return nodes.some((node: any) => {
            if (node.id === component.state.alterNodeId) {
                return (
                    node.parentId !== null &&
                    this.isRemoved(node.parentId, this.state.brokerTreeNodes)
                );
            } else if (node.children && node.children.length > 0) {
                return this.hasRemovedParent(node.children);
            }
        });
    }

    isRemoved(nodeId: number, nodeTree?: any) {
        let nodes = nodeTree ? nodeTree : this.state.brokerTreeNodes;
        let component = this;

        return nodes.some((node: any) => {
            if (node.id === nodeId) {
                return node.isRemoved;
            } else if (node.children && node.children.length > 0) {
                return this.isRemoved(nodeId, node.children);
            }
        });
    }

    doNodeRestore() {
        this.props.actions
            .restoreBrokerTreeNode(this.state.alterNodeId)
            .then(() => {
                this.closeAlterNodeConfirmModal();
            })
            .catch((error: any) => handleError(error));
    }

    toggleNode(nodeId: number) {
        const item = this.findNode(this.state.brokerTreeNodes, nodeId);
        this.props.actions.getBrokerTree(nodeId, item.toggle);
    }

    toggleNodeLocal(tree: any[], id: number) {
        for (let i = 0; i < tree.length; i++) {
            if (tree[i].children) {
                if (tree[i].id === id) {
                    tree[i].toggle = !tree[i].toggle;
                    break;
                }

                tree[i].children = this.toggleNodeLocal(tree[i].children, id);
            }
        }

        return tree;
    }

    render() {
        return (
            <div>
                <h1>{Translate('broker-tree/title')}</h1>
                <ControlLabel>{Translate('broker-tree/search')}</ControlLabel>
                <Row>
                    <Col xs={6}>
                        <FormGroup>
                            <FormControl
                                type="text"
                                name="search"
                                onKeyPress={(e: any) => {
                                    if (e.key === 'Enter') {
                                        this.onSearch();
                                    }
                                }}
                                value={this.state.searchFilter ? this.state.searchFilter : ''}
                                onChange={this.search}
                            />
                        </FormGroup>
                    </Col>
                    <Col xs={6}>
                        <Button
                            bsStyle="success"
                            bsSize="sm"
                            onClick={this.onSearch}
                            disabled={this.state.searching}
                        >
                            {this.state.searching && <i className="load-spin-dark"></i>}
                            {!this.state.searching && <i className="material-icons">search</i>}{' '}
                            Search
                        </Button>
                    </Col>
                </Row>

                <Button
                    bsStyle="primary"
                    bsSize="sm"
                    onClick={() => {
                        this.addNewItem({}, 'chain');
                    }}
                >
                    <i className="material-icons">add</i> {Translate('broker-tree/new-chain')}
                </Button>

                <Checkbox
                    className="pull-right"
                    inline
                    name="showRemoved"
                    checked={this.state.showRemovedNodes ? this.state.showRemovedNodes : false}
                    onChange={this.toggleShowRemoved}
                >
                    <span>
                        {Translate('broker-tree/page/checkbox-label/show-removed-customers')}
                    </span>
                </Checkbox>

                <TreeView
                    data={this.state.brokerTreeNodes}
                    onToggle={this.toggleNode}
                    onChange={this.updateTree}
                    onClick={this.selectItem}
                    onAdd={this.addNewItem}
                    onMove={this.moveNode}
                    onDelete={this.deleteNode}
                    onRestore={this.restoreNode}
                    showLogs={this.toggleLogs}
                    canCreate={Features.hasFeature(Features.CreateBrokerTreeNode, this.props.user)}
                    canMove={Features.hasFeature(Features.MoveBrokerTreeNode, this.props.user)}
                    canDelete={Features.hasFeature(Features.DeleteBrokerTreeNode, this.props.user)}
                    canRestore={Features.hasFeature(
                        Features.RestoreBrokerTreeNode,
                        this.props.user
                    )}
                />

                {this.renderModal()}

                {this.state.showLogs && (
                    <LogsModal
                        id={this.state.logEntityId}
                        type={this.state.logProperty}
                        shouldShowModal={this.state.showLogs}
                        closeModal={() => this.toggleLogs(this.state.logEntityId)}
                    />
                )}

                {this.state.showMoveNodeConfirmModal && (
                    <ConfirmationModal
                        title={Translate('broker-tree/move-confirmation/title')}
                        text={Translate('broker-tree/move-confirmation/text')}
                        doButtonLabel={Translate(
                            'broker-tree/move-confirmation/button-labels/move'
                        )}
                        cancelButtonLabel={Translate(
                            'broker-tree/move-confirmation/button-labels/cancel'
                        )}
                        doButtonStyle="danger"
                        do={this.doNodeMove}
                        closeModal={this.closeAlterNodeConfirmModal}
                    />
                )}
                {this.state.showDeleteNodeConfirmModal && (
                    <ConfirmationModal
                        title={Translate('broker-tree/delete-confirmation/title')}
                        text={
                            this.hasChildren()
                                ? Translate(
                                    'broker-tree/delete-confirmation/text-with-node-children'
                                )
                                : Translate('broker-tree/delete-confirmation/text')
                        }
                        doButtonLabel={Translate(
                            'broker-tree/delete-confirmation/button-labels/delete'
                        )}
                        cancelButtonLabel={Translate(
                            'broker-tree/delete-confirmation/button-labels/cancel'
                        )}
                        doButtonStyle="danger"
                        do={this.doNodeDelete}
                        closeModal={this.closeAlterNodeConfirmModal}
                    />
                )}

                {this.state.showRestoreNodeConfirmModal && (
                    <ConfirmationModal
                        title={Translate('broker-tree/restore-confirmation/title')}
                        text={
                            this.hasRemovedParent()
                                ? Translate(
                                    'broker-tree/restore-confirmation/text-with-customer-parent'
                                )
                                : Translate('broker-tree/restore-confirmation/text')
                        }
                        doButtonLabel={Translate(
                            'broker-tree/restore-confirmation/button-labels/restore'
                        )}
                        cancelButtonLabel={Translate(
                            'broker-tree/restore-confirmation/button-labels/cancel'
                        )}
                        doButtonStyle="danger"
                        do={this.doNodeRestore}
                        closeModal={this.closeAlterNodeConfirmModal}
                    />
                )}
            </div>
        );
    }

    toggleLogs(id: number) {
        const item = this.findNode(this.state.brokerTreeNodes, id);
        if (item) {
            let { logProperty } = this.state;
            if (item.type === 'firm') {
                logProperty = 'BrokerFirmId';
            } else if (item.type === 'chain') {
                logProperty = 'BrokerChainId';
            } else if (item.type === 'firmGroup') {
                logProperty = 'BrokerFirmGroupId';
            } else {
                logProperty = 'UserId';
            }
            this.setState({
                showLogs: !this.state.showLogs,
                logEntityId: item.brokerEntityId,
                logProperty: logProperty
            });
        } else {
            this.setState({ showLogs: !this.state.showLogs });
        }
    }

    handleOnCreatedBrokerAgent = () => {
        let { currentItem } = this.state;
        let { actions } = this.props;

        actions.getBrokerTree(currentItem.parentId, null, null, this.props.match.params.nodeId);
    }

    renderModal() {
        if (this.state.showChainModal) {
            return <ChainModal onClose={this.closeModals} item={this.state.currentItem} />;
        }

        if (this.state.showFirmGroupModal) {
            return <FirmGroupModal onClose={this.closeModals} item={this.state.currentItem} />;
        }

        if (this.state.showFirmModal) {
            return <FirmModal onClose={this.closeModals} item={this.state.currentItem} />;
        }

        if (this.state.showAgentModal) {
            return (
                <AgentModal
                    onClose={(wasMoved) => {
                        this.closeModals();
                        if (wasMoved) {
                            this.props.actions.getBrokerTree(
                                null,
                                null,
                                null,
                                this.props.params.nodeId
                            );
                        }
                    }}
                    onCreated={this.handleOnCreatedBrokerAgent}
                    item={this.state.currentItem}
                />
            );
        }

        return null;
    }

    closeModals() {
        this.setState({
            currentParentId: null,
            showChainModal: false,
            showFirmGroupModal: false,
            showFirmModal: false,
            showAgentModal: false
        });
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        brokerTreeNodes: state.brokers.list,
        showRemovedNodes: state.brokers.showRemovedNodes,
        user: state.user
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getBrokerTree: (
                parentNodeId: number = null,
                toggle: boolean = null,
                search: string = null,
                nodeId: number = null
            ) => dispatch(brokerActions.getBrokerTree(parentNodeId, toggle, search, nodeId)),
            updateBrokerTree: (tree: any[]) => dispatch(brokerActions.updateBrokerTree(tree)),
            addBrokerTreeNode: (data: any) => dispatch(brokerActions.addBrokerTree(data)),
            moveBrokerTreeNode: (id: number, data: any) =>
                dispatch(brokerActions.moveBrokerTree(id, data)),
            deleteBrokerTreeNode: (id: number) => dispatch(brokerActions.deleteBrokerTree(id)),
            restoreBrokerTreeNode: (id: number) => dispatch(brokerActions.restoreBrokerTree(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BrokerTreePage);
